"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypoAndLoaderDimensions = void 0;
var Typo_1 = require("../../Typo");
var getTypoAndLoaderDimensions = function (size) {
    if (size === void 0) { size = 'M'; }
    switch (size) {
        case 'L':
            return { TypoComp: Typo_1.SANS_4_5, trackThickness: 10, diameter: 70 };
        case 'S':
            return { TypoComp: Typo_1.SANS_2, trackThickness: 3.65, diameter: 21.35 };
        case 'M':
        default:
            return { TypoComp: Typo_1.SANS_3, trackThickness: 7, diameter: 43 };
    }
};
exports.getTypoAndLoaderDimensions = getTypoAndLoaderDimensions;
